import React, { useState, useRef, useEffect } from "react";
import { RiResetLeftFill } from "react-icons/ri";
import { FaChevronDown, FaPlus } from "react-icons/fa";
import { MdOutlineImageNotSupported } from "react-icons/md";

import bg from "../assets/images/bg.webp";
import { httpss } from '../utils/host';
import axios from 'axios';
import logomyH from '../assets/images/logomyH.png';
import QRCodeStyling from "qr-code-styling";
import { logoOptions } from '../components/donvi';

const pageStyles = {
    fontFamily: "-apple-system, Roboto, sans-serif, serif",
    backgroundImage: `url(${bg})`, 
    minHeight:"90vh", 
    backgroundPosition: 'center', 
    backgroundSize: 'cover'
};

const valueSelectStyleQR = [
        { value: "square", label: "Vuông",},
        { value: "classy", label: "Thanh lịch",},
        { value: "classy-rounded", label: "Bo tròn thanh lịch",},
        { value: "dots", label: "Nhiều chấm",},
        { value: "dot", label: "Chấm",},
        { value: "rounded", label: "Bo tròn",},
        { value: "extra-rounded", label: "Bo tròn đặc biệt",},
    ]

function QRPage() {
    const [mail, setMail] = useState(sessionStorage.getItem('mail'));
    const [data, setData] = useState([]);
    const [link, setLink] = useState('');
    const [shortLink, setShortLink] = useState('');
    const [qrUrl, setQrUrl] = useState('');
    const [historyQrUrls, setHistoryQrUrls] = useState({});
    const [errMsg, setErrMsg] = useState({ link: '', shortLink: '', qrError: '' });
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const [isformatLogoQR, setIsformatLogoQR] = useState(false);
    const [isformatStyleQR, setIsformatStyleQR] = useState(false);
    const [isformatColorQR, setIsformatColorQR] = useState(false);
    const [isPreviewQR, setIsPreviewQR] = useState(false);

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState('');
    const [sortField, setSortField] = useState('createdAt');
    const [sortOrder, setSortOrder] = useState('DESC');
    const [isLoading, setIsLoading] = useState(true);
    const fileInputRef = useRef(null);

    const [settings, setSettings] = useState(() => {
        const savedSettings = localStorage.getItem("qrSettings");
        return savedSettings ? JSON.parse(savedSettings) : {
            width: 500,
            height: 500,
            type: "svg",
            shape: "square",
            data: window.location.href,
            image: logomyH,
            margin: 1,
            dotsOptionsColor: "#000000",
            dotsOptionsType: "dots",
            backgroundOptionsColor: "#ffffff",
            cornersSquareOptionsType: "extra-rounded",
            cornersSquareOptionsColor: "#000000",
            cornersDotOptionsType: "extra-rounded",
            cornersDotOptionsColor: "#000000",
            imageOptions_crossOrigin: "anonymous",
            imageOptions_margin: 1,
        };
    });


  const handleChange = (field, value) => {
    const newSettings = { ...settings, [field]: value };
    setSettings(newSettings);
    localStorage.setItem("qrSettings", JSON.stringify(newSettings)); // Lưu vào localStorage
  };

    const getData = async () => {
        try {
            setIsLoading(true);
            const response = await axios.post(`${httpss}/apis_v1/qr/history_user`, { 
                mail,
                page,
                limit,
                search,
                sortField,
                sortOrder
            });
            if (response.status === 200) {
                setData(response.data.data);
                setTotalPages(response.data.pagination.totalPages);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => { 
        getData(); 
    }, [mail, qrUrl, selectedItem, page, limit, search, sortField, sortOrder]);

    const convertToSlug = (str) => {
        str = str.toLowerCase();
        str = str.replace(/(à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ)/g, 'a');
        str = str.replace(/(è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ)/g, 'e');
        str = str.replace(/(ì|í|ị|ỉ|ĩ)/g, 'i');
        str = str.replace(/(ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ)/g, 'o');
        str = str.replace(/(ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ)/g, 'u');
        str = str.replace(/(ỳ|ý|ỵ|ỷ|ỹ)/g, 'y');
        str = str.replace(/(đ)/g, 'd');
        str = str.replace(/([^0-9a-z-\s])/g, '');
        str = str.replace(/(\s+)/g, '-');
        str = str.replace(/-+/g, '-');
        str = str.replace(/^-+/g, '');
        str = str.replace(/-+$/g, '');
        return str;
    }

    const createQR = async () => {
        if (!link || !shortLink) {
            setErrMsg({ link: !link ? 'Vui lòng điền thông tin' : '', shortLink: !shortLink ? 'Vui lòng điền thông tin' : '' });
            return;
        }
    
        const shortLinkAfterConvert = convertToSlug(shortLink);
    
        const result = await axios.post(`${httpss}/apis_v1/qr/create_qr`, { 
            link, 
            slug: shortLinkAfterConvert, 
            text: shortLink, 
            mail, 
            typeQR: JSON.stringify(settings)
        });
    
        if (result.status === 200) {
            if (result.data.status === 3 || result.data.status === 2) {
                const url = await generateQRCode(`${window.location.href}${shortLinkAfterConvert}`, settings);
                setQrUrl(url);
                setIsPreviewQR(true);
                setErrMsg({ ...errMsg, qrError: result.data.status === 2 ? result.data.msg : '' });
            } else {
                setQrUrl('');
                setErrMsg({ ...errMsg, qrError: result.data.msg });
            }
        }
    };
    
    
    const generateQRCode = async (data, customSettings = null) => {
        try {
            const settingsToUse = customSettings || settings;
    
            const qrCodeStyling = new QRCodeStyling({
                width: settingsToUse.width,
                height: settingsToUse.width,
                type: settingsToUse.type,
                shape: settingsToUse.shape,
                image: settingsToUse.image,
                margin: settingsToUse.margin,
                data: settingsToUse.data,
                dotsOptions: { color: settingsToUse.dotsOptionsColor, type: settingsToUse.dotsOptionsType },
                backgroundOptions: { color: settingsToUse.backgroundOptionsColor },
                cornersSquareOptions: { type: settingsToUse.cornersSquareOptionsType, color: settingsToUse.cornersSquareOptionsColor },
                cornersDotOptions: { type: settingsToUse.cornersDotOptionsType, color: settingsToUse.cornersDotOptionsColor },
                imageOptions: { crossOrigin: "anonymous", margin: settingsToUse.imageOptions_margin },
              });
    
            qrCodeStyling.update({ data });
    
            // Xuất file ảnh QR code
            // const blob = await qrCodeStyling.getRawData(settingsToUse.type === "svg" ? "svg" : "png");
            const blob = await qrCodeStyling.getRawData('png');
            return URL.createObjectURL(blob);
        } catch (error) {
            console.error("Error generating QR code:", error);
            return null;
        }
    };
    

    useEffect(() => {
        if (settings) { 
            const generateAndShowQRCode = async () => {
                const url = await generateQRCode(`${window.location.href}${shortLink}`, settings);
                setQrUrl(url);
            };
            generateAndShowQRCode();
        }
    }, [settings, shortLink]); 

    const downloadQR = async (id, slug) => {
        try {
            const url = id ? historyQrUrls[id] : qrUrl;
            if (!url) return;

            const response = await fetch(url);
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `qrcode-${id || slug || "default"}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error("Error downloading QR code:", error);
        }
    };

    const generateHistoryQrCodes = async () => {
        try {
            const urls = {};
            for (const item of data) {
                if (item.typeQR) {
                    const settings = JSON.parse(item.typeQR);
                    const url = await generateQRCode(`${window.location.href}${item.slug}`, settings);
                    if (url) {
                        urls[item.id] = url;
                    }
                }
            }
            setHistoryQrUrls(urls);
        } catch (error) {
            console.error("Error generating history QR codes:", error);
        }
    };
    
    

    useEffect(() => {
        if (data?.length > 0 && settings) {
            generateHistoryQrCodes();
        }
    }, [data, settings]); 

    const handleUpdate = (item) => {
        setSelectedItem(item);
        setIsPopupVisible(true);
    };

    const handleSaveChanges = async () => {
        const shortLinkAfterConvert = convertToSlug(selectedItem.text);
        const result = await axios.post(`${httpss}/apis_v1/qr/update_data_admin`, { ...selectedItem, slug: shortLinkAfterConvert, mail });
        if (result.status === 200) {
            alert(result.data.status === 3 ? 'Cập nhật thành công' : result.data.msg);
            setIsPopupVisible(false);
            getData();
        }
    };

    return (
        <div style={pageStyles}>
                <div className='container mx-auto px-2 py-4'>
                    <div className='md:flex bg-white'>
                        <div className='w-full py-4'>
                            {/* <img src={logomyH} alt="Logo Hung Hau" className="w-24 mx-auto" /> */}
                            <h2 className='text-center text-2xl font-bold text-[#0266B4]'>Rút gọn link</h2>
                            <div className='p-2 w-full group relative'>
                                <input type="text" className='p-4 border outline-none w-full hover:border-gray-400 rounded shadow' placeholder='Nhập link' value={link} onChange={(e) => { setLink(e.target.value); setErrMsg({ ...errMsg, link: '' }); }} />
                                  <span className="absolute left-0 -top-6 text-sm text-white bg-black px-2 py-1 rounded shadow opacity-0 group-hover:opacity-100 transition-opacity">
                                    Nhập link dài mà bạn cần rút gọn
                                </span>
                                {errMsg.link && <p className='text-red-600 px-4'>{errMsg.link}</p>}
                            </div>
                            <div className='p-2 flex flex-col gap-2 w-full  group relative'>
                                <input type="text" className='p-4 border outline-none w-full hover:border-gray-400 rounded shadow' placeholder='Nhập short link' value={shortLink} onChange={(e) => { setShortLink(e.target.value); setErrMsg({ ...errMsg, shortLink: '' }); }} />
                                <span className="absolute left-0 -top-6 text-sm text-white bg-black px-2 py-1 rounded shadow opacity-0 group-hover:opacity-100 transition-opacity">
                                    Nhập link ngắn mà sẽ rút gọn
                                </span>
                                {shortLink && <a className='text-[#0266B4] hover:underline px-4' target='_blank' href={`${window.location.href}${convertToSlug(shortLink)}`}>{`${window.location.href}${convertToSlug(shortLink)}`}</a>}
                                {errMsg.shortLink && <p className='text-red-600 px-4'>{errMsg.shortLink}</p>}
                            </div>

                            <div className="px-2">
                                <button onClick={()=> setIsformatLogoQR(!isformatLogoQR)} className="flex justify-between items-center w-full mt-4 px-4 py-2 bg-[#0266B4] text-white rounded hover:bg-[#125e99] my-2">
                                <p>Logo QR</p>
                                <FaChevronDown className={`transition-transform duration-300 ${isformatLogoQR ? 'rotate-360' : 'rotate-90'}`} />
                                </button>
                                {isformatLogoQR && (
                                    <div className="grid grid-cols-7 gap-2 p-2 rounded my-2">
                                        {logoOptions.map((logo, index) => (
                                            <button
                                                key={index}
                                                type="button"
                                                onClick={() => handleChange("image", logo)}
                                                className={`
                                                    flex items-center justify-center aspect-square w-12 h-12 rounded border-2
                                                    transition-all duration-200
                                                    ${settings.image === logo ? 'border-[#4AB253] ring-2 ring-[#4AB253]' : 'border-gray-200'}
                                                    hover:scale-105 hover:border-[#4AB253] bg-white
                                                `}
                                                style={{ padding: 0 }}
                                            >
                                                <img
                                                    src={logo}
                                                    alt="Logo"
                                                    className="object-contain w-8 h-8"
                                                    draggable={false}
                                                />
                                            </button>
                                        ))}
                                        <button
                                            type="button"
                                            onClick={() => handleChange("image", null)}
                                            className={`
                                                flex items-center justify-center aspect-square w-12 h-12 rounded border-2
                                                transition-all duration-200
                                                ${settings.image === null ? 'border-red-500 ring-2 ring-red-400 bg-red-50' : 'border-gray-200'}
                                                hover:scale-105 hover:border-red-400 bg-white
                                            `}
                                        >
                                            <MdOutlineImageNotSupported className="text-xl text-red-500" />
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                            className={`
                                                flex items-center justify-center aspect-square w-12 h-12 rounded border-2 border-dashed
                                                transition-all duration-200
                                                hover:scale-105 hover:border-green-500 bg-white
                                            `}
                                        >
                                            <FaPlus size={18} className="text-[#4AB253]" />
                                        </button>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            accept="image/*"
                                            onChange={(e) => handleChange("image", URL.createObjectURL(e.target.files[0]))}
                                            className="hidden"
                                        />
                                    </div>
                                )}
                                <button onClick={()=> setIsformatStyleQR(!isformatStyleQR)} className="flex justify-between items-center w-full mt-4 px-4 py-2 bg-[#0266B4] text-white rounded hover:bg-[#125e99] my-2">
                                <p>Định dạng QR</p>
                                <FaChevronDown className={`transition-transform duration-300 ${isformatStyleQR ? 'rotate-360' : 'rotate-90'}`} />
                                </button>
                                {isformatStyleQR && (
                                    <div>
                                    <div>
                                        <label>Hình dạng</label>
                                        <select value={settings.shape} onChange={(e) => handleChange("shape", e.target.value)} className="w-full p-2 border border-gray-300 rounded">
                                        <option value="square">Vuông</option>
                                        <option value="circle">Tròn</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label>Kiểu chấm _ loại</label>
                                        <select value={settings.dotsOptionsType} onChange={(e) => handleChange("dotsOptionsType", e.target.value)} className="w-full p-2 border border-gray-300 rounded">
                                        {valueSelectStyleQR.map((item) => ( <option value={item.value}>{item.label}</option> ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label>Bo gốc _ loại</label>
                                        <select value={settings.cornersSquareOptionsType} onChange={(e) => handleChange("cornersSquareOptionsType", e.target.value)} className="w-full p-2 border border-gray-300 rounded">
                                        {valueSelectStyleQR.map((item) => ( <option value={item.value}>{item.label}</option> ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label>Chấm gốc _ loại</label>
                                        <select value={settings.cornersDotOptionsType} onChange={(e) => handleChange("cornersDotOptionsType", e.target.value)} className="w-full p-2 border border-gray-300 rounded">
                                        {valueSelectStyleQR.map((item) => ( <option value={item.value}>{item.label}</option> ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label>Kích thước</label>
                                        <div className="flex w-full p-2 border border-gray-300 rounded">
                                            <p className="w-full">{settings.width}x{settings.width}</p>
                                            <input type="range" min="100" max="1000" step={10} placeholder="Nhập kích thước..." value={settings.width} onChange={(e) => handleChange("width", e.target.value)} className="w-full"/>
                                        </div>
                                    </div>
                                    <div>
                                        <label>Lề logo</label>
                                        <input type="text" placeholder="Nhập logo lề..." value={settings.imageOptions_margin} onChange={(e) => handleChange("imageOptions_margin", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                                    </div>
                                    <div>
                                        <label>Lề QR</label>
                                        <input type="text" placeholder="Nhập QR lề..." value={settings.margin} onChange={(e) => handleChange("margin", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                                    </div>
                                    </div>
                                )}
                                <button onClick={()=> setIsformatColorQR(!isformatColorQR)} className="flex justify-between items-center w-full mt-4 px-4 py-2 bg-[#0266B4] text-white rounded hover:bg-[#125e99] my-2">
                                <p>Định dạng màu QR</p>
                                <FaChevronDown className={`transition-transform duration-300 ${isformatColorQR ? 'rotate-360' : 'rotate-90'}`} />
                                </button>
                                {isformatColorQR && (
                                    <div>
                                    <div>
                                        <label>Kiểu chấm</label>
                                        <div className="flex gap-2">
                                            <input type="color" placeholder="Chọn màu sắc..." value={settings.dotsOptionsColor} onChange={(e) => handleChange("dotsOptionsColor", e.target.value)} className="w-full p-2 h-10 border border-gray-300 rounded"/>
                                            <input type="text" placeholder="Nhập màu sắc..." value={settings.dotsOptionsColor} onChange={(e) => handleChange("dotsOptionsColor", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                                        </div>
                                        </div>
                                        <div>
                                        <label>Màu nền</label>
                                        <div className="flex gap-2">
                                            <input type="color" placeholder="Chọn màu nền..." value={settings.backgroundOptionsColor} onChange={(e) => handleChange("backgroundOptionsColor", e.target.value)} className="w-full p-2 h-10 border border-gray-300 rounded"/>
                                            <input type="text" placeholder="Nhập màu nền..." value={settings.backgroundOptionsColor} onChange={(e) => handleChange("backgroundOptionsColor", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                                        </div>
                                        </div>
                                        <div>
                                        <label>Bo gốc</label>
                                        <div className="flex gap-2">
                                            <input type="color" placeholder="Chọn bo gốc màu sắc..." value={settings.cornersSquareOptionsColor} onChange={(e) => handleChange("cornersSquareOptionsColor", e.target.value)} className="w-full p-2 h-10 border border-gray-300 rounded"/>
                                            <input type="text" placeholder="Nhập bo gốc màu sắc..." value={settings.cornersSquareOptionsColor} onChange={(e) => handleChange("cornersSquareOptionsColor", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                                        </div>
                                        </div>
                                        <div>
                                        <label>Chấm gốc</label>
                                        <div className="flex gap-2">
                                            <input type="color" placeholder="Chọn chấm gốc màu..." value={settings.cornersDotOptionsColor} onChange={(e) => handleChange("cornersDotOptionsColor", e.target.value)} className="w-full p-2 h-10 border border-gray-300 rounded"/>
                                            <input type="text" placeholder="Nhập chấm gốc màu..." value={settings.cornersDotOptionsColor} onChange={(e) => handleChange("cornersDotOptionsColor", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                                        </div>
                                        </div>
                        
                                    </div>
                                )}
                                <div className="flex justify-between items-center mt-4 gap-3">
                                <button onClick={createQR} className="w-full py-2 bg-[#4AB253] hover:bg-[#4AB253]/80 text-white rounded">Tạo QR</button>
                                <button onClick={()=>{localStorage.clear("qrSettings"); window.location.reload();}} className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded text-2xl"><RiResetLeftFill/></button>
                                </div>
                            </div>

                        </div>
                        <div className='w-full'>
                            <div className='flex justify-center items-center p-2'>
                                {qrUrl && <div> {
                                    isPreviewQR ? (
                                        <div>
                                            <img src={qrUrl} alt="QR Code" className="border rounded-xl m-2 p-2 w-[300px] shadow" />
                                            <div className="flex justify-center">
                                                <button onClick={() => downloadQR()} className='px-5 py-1 bg-[#0266B4] hover:bg-[#0266B4]/80 text-white rounded text-nowrap'>Tải QR</button>
                                            </div>
                                        </div>
                                    ):(
                                        <div className='opacity-30'>
                                            <img src={qrUrl} alt="QR Code" className="border rounded-xl m-2 p-2 w-[300px] shadow" />
                                            <p className='text-center'>Xem trước QR</p>
                                        </div>
                                    )
                                }
                                </div>}
                            </div>
                                {errMsg.qrError && <p className='text-red-600 text-center mb-4'>{errMsg.qrError}</p>}
                        </div>

                    </div>
                    {data && (
                        <div className='p-2 mt-4 bg-white'>
                            <div className="flex justify-between items-center">
                                <h2 className='text-center text-2xl font-bold text-[#0266B4] my-4'>Lịch sử</h2>
                                <div className="flex items-center gap-2">
                                    <input
                                        type="text"
                                        placeholder="Tìm kiếm..."
                                        value={search}
                                        onChange={(e) => {
                                            setSearch(e.target.value);
                                            setPage(1);
                                        }}
                                        className="p-2 border rounded outline-none"
                                    />
                                    
                                </div>
                                
                            </div>
                                {search && data.length === 0 && (
                                    <p className="text-center text-orange-500 italic mt-4">
                                        Không tìm thấy kết quả cho từ khóa: "{search}"
                                    </p>
                                )}
                            <div className="overflow-x-auto rounded-lg h-[80vh] custom-scrollbar max-lg:hidden ">
                                <table className='w-full border text-sm text-left rounded-lg'>
                                    <thead className='sticky top-0 bg-gray-200 z-0'>
                                        <tr>
                                            <th className='p-2 border border-gray-400'>STT</th>
                                            <th className='p-2 border border-gray-400' onClick={() => setSortField('link')}>Link {sortField === 'link' && (sortOrder === 'DESC' ? '↑' : '↓')}</th>
                                            <th className='p-2 border border-gray-400' onClick={() => setSortField('slug')}>Short Link {sortField === 'slug' && (sortOrder === 'DESC' ? '↑' : '↓')}</th>
                                            <th className='p-2 border border-gray-400' onClick={() => setSortField('createdAt')}>Ngày tạo {sortField === 'createdAt' && (sortOrder === 'DESC' ? '↑' : '↓')}</th>
                                            <th className='p-2 border border-gray-400' onClick={() => setSortField('count')}>Lượt truy cập {sortField === 'count' && (sortOrder === 'DESC' ? '↑' : '↓')}</th>
                                            <th className='p-2 border border-gray-400'>Mã QR</th>
                                            <th className='p-2 border border-gray-400'>Thao tác</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((item, index) => (
                                            <tr key={index}>
                                                <td className='p-2 border border-gray-400'>{index + 1}</td>
                                                <td className='p-2 border border-gray-400 break-all'><a className='text-[#0266B4] hover:underline' href={item.link} target="_blank" rel="noopener noreferrer">{item.link.slice(0, 20)+'...'}</a></td>
                                                <td className='p-2 border border-gray-400'><a className='text-[#0266B4] hover:underline' target='_blank' href={`${window.location.href}${item.slug}`}>{`${window.location.href}${item.slug.slice(0, 50)+'...'}`}</a></td>
                                                <td className='p-2 border border-gray-400'>{new Date(item.createdAt).toLocaleString('vi-VN')}</td>
                                                <td className='p-2 border border-gray-400'>{item.count}</td>
                                                <td className='p-2 border border-gray-400'>
                                                    {isLoading ? (
                                                        <div className="flex justify-center items-center h-32">
                                                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0266B4]"></div>
                                                        </div>
                                                    ) : historyQrUrls[item.id] ? (
                                                        <img 
                                                            src={historyQrUrls[item.id]} 
                                                            alt="QR Code" 
                                                            className="mx-auto my-auto border rounded-xl w-32 m-1 p-1 shadow"
                                                            loading="lazy"
                                                        />
                                                    ) : (
                                                        <div className="text-center text-gray-500">QR không khả dụng</div>
                                                    )}
                                                </td>
                                                <td className='p-2 border border-gray-400'>
                                                    <div className='flex flex-col gap-2'>
                                                        <button onClick={() => downloadQR(item.id)} className='px-5 py-1 bg-[#0266B4] hover:bg-[#0266B4]/80 text-white rounded text-nowrap'>Tải QR</button>
                                                        <button onClick={() => handleUpdate(item)} className='px-5 py-1 bg-[#0266B4] hover:bg-[#0266B4]/80 text-white rounded'>Sửa</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className='overflow-x-auto rounded-lg h-[80vh] custom-scrollbar lg:hidden '>
                                {data?.map((item, index) => (
                                    <div key={index} className='border-2 my-2 p-1 rounded'>
                                        <p>Link: <a className='text-[#0266B4] hover:underline' href={item.link} target="_blank" rel="noopener noreferrer">{item.link.slice(0, 20)+'...'}</a></p>
                                        <p>Short Link: <a className='text-[#0266B4] hover:underline' target='_blank' href={`${window.location.href}${item.slug}`}>{`${window.location.href}${item.slug.slice(0, 50)+'...'}`}</a></p>
                                        <p>Ngày tạo: {new Date(item.createdAt).toLocaleString('vi-VN')}</p>
                                        <p>Lượt truy cập: {item.count}</p>
                                        <div>
                                            {historyQrUrls[item.id] && (
                                                <img 
                                                    src={historyQrUrls[item.id]} 
                                                    alt="QR Code" 
                                                    className="mx-auto my-auto border rounded-xl w-32 m-1 p-1 shadow"
                                                />
                                            )}
                                        </div>
                                        <div className='flex gap-2'>
                                            <button onClick={() => downloadQR(item.id)} className='px-5 py-1 bg-[#0266B4] hover:bg-[#0266B4]/80 text-white rounded w-full text-nowrap'>Tải QR</button>
                                            <button onClick={() => handleUpdate(item)} className='px-5 py-1 bg-[#0266B4] hover:bg-[#0266B4]/80 text-white rounded w-full'>Sửa</button>
                                        </div>
                                    </div>
                                ))}
                            </div>

                                                <div className="flex justify-between items-center mt-4">
                        <div className="flex items-center gap-2">
                            <button
                                disabled={page <= 1}
                                onClick={() => setPage((p) => Math.max(1, p - 1))}
                                className="px-2 py-1 border rounded disabled:opacity-50"
                            >
                                &lt;
                            </button>
                            <div>
                                Trang {page} / {totalPages}
                            </div>
                            <button
                                disabled={page >= totalPages}
                                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                                className="px-2 py-1 border rounded disabled:opacity-50"
                            >
                                &gt;
                            </button>
                        </div>
                        <div className="flex items-center gap-2">
                            <label>Số dòng mỗi trang:</label>
                            <select
                                className="border rounded p-1"
                                value={limit}
                                onChange={(e) => {
                                    setPage(1);
                                    setLimit(Number(e.target.value));
                                }}
                            >
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={200}>200</option>
                                <option value={500}>500</option>
                            </select>
                        </div>
                    </div>
                        </div>
                    )}

                    {isPopupVisible && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                            <div className="bg-white p-6 rounded shadow-lg w-[400px]">
                                <h3 className="text-lg font-bold mb-4 text-center">Sửa thông tin</h3>
                                <div className="mb-4">
                                    <label className="block font-medium mb-2">Link</label>
                                    <input type="text" className="w-full p-2 border rounded" value={selectedItem?.link || ""} onChange={(e) => setSelectedItem((prev) => ({ ...prev, link: e.target.value }))} />
                                </div>
                                <div className="mb-4">
                                    <label className="block font-medium mb-2">Short Link</label>
                                    <input type="text" className="w-full p-2 border rounded" value={selectedItem?.text || ""} onChange={(e) => setSelectedItem((prev) => ({ ...prev, text: e.target.value }))} />
                                </div>
                                <div className="flex justify-end gap-4">
                                    <button className="px-4 py-2 bg-gray-300 rounded" onClick={() => setIsPopupVisible(false)}>Hủy</button>
                                    <button className="px-4 py-2 bg-blue-500 text-white rounded" onClick={handleSaveChanges}>Lưu</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
        </div>
    );
}

export default QRPage;